"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextView = void 0;
var tslib_1 = require("tslib");
/** @jsxRuntime classic */
/** @jsx withSlots */
var foundation_legacy_1 = require("@fluentui/foundation-legacy");
var Utilities_1 = require("../../Utilities");
var TextView = function (props) {
    // eslint-disable-next-line eqeqeq
    if (props.children == null) {
        return null;
    }
    var block = props.block, className = props.className, _a = props.as, RootType = _a === void 0 ? 'span' : _a, variant = props.variant, nowrap = props.nowrap, rest = tslib_1.__rest(props, ["block", "className", "as", "variant", "nowrap"]);
    var Slots = foundation_legacy_1.getSlots(props, {
        root: RootType,
    });
    return foundation_legacy_1.withSlots(Slots.root, tslib_1.__assign({}, Utilities_1.getNativeProps(rest, Utilities_1.htmlElementProperties)));
};
exports.TextView = TextView;
//# sourceMappingURL=Text.view.js.map